import { assertUnreachable, isDefined } from '@sgme/fp';

import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { getQuote, selectRfsStatus } from '@/store/option/selectors/optionSelectors.ts';

import { Awaiting } from './components/Awaiting.tsx';
import { NotPriceable } from './components/NotPriceable.tsx';
import { Priceable } from './components/Priceable.tsx';
import { Streaming } from './components/Streaming.tsx';
import { StreamingError } from './components/StreamingError.tsx';

type BidAskProps = {
  tileId: string;
};

export function BidAsk({ tileId }: BidAskProps) {
  const rfsStatus = useOptionSelector((option) => selectRfsStatus(option));
  const quote = useOptionSelector((option) => getQuote(option));

  switch (rfsStatus) {
    case 'NOT_PRICEABLE':
      return <NotPriceable />;
    case 'PRICEABLE':
      if (isDefined(quote)) {
        return <Streaming tileId={tileId} />;
      }
      return <Priceable />;
    case 'AWAITING_INDICATIVE':
      return <Awaiting forceTradeable={false} />;
    case 'AWAITING_EXECUTABLE':
      return <Awaiting forceTradeable={true} />;
    case 'STREAMING_INDICATIVE':
      return <Streaming tileId={tileId} />;
    case 'STREAMING_EXECUTABLE':
      return <Streaming tileId={tileId} executable={true} />;
    case 'ERROR':
      return <StreamingError />;
    case 'BYPASSABLE_ERROR':
      return <StreamingError />;
    default:
      return assertUnreachable(rfsStatus, `Unknown price status: ${rfsStatus}`);
  }
}

